(() => {
  if (customElements.get('bs-support-contact')) return;

  class BullseatSupportContact extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      const modelSelect = this.querySelector('[name="contact[Modell]"]');
      if (modelSelect) {
        [...modelSelect.options].filter(option => option.value !== 'Unbekannt')
          .sort((a, b) => a.text.localeCompare(b.text, 'de', { numeric: true }))
          .forEach(option => modelSelect.append(option));
      }
      // Do not overwrite submitted values when Shopify returns a form error.
      if (this.querySelector('[data-bs-contact-errors]')) return;
      const params = new URLSearchParams(window.location.search);
      const aliases = { montage: 'Montage', passform: 'Passform', ersatzteile: 'Ersatzteile', produkt: 'Produktproblem', bestellung: 'Bestellung', pflege: 'Pflege', allgemein: 'Allgemein' };
      // Older product links use one context value; newer links pass topic/model.
      // Values are only assigned to existing select options, never inserted as HTML.
      const context = (params.get('context') || '').trim();
      const contextTopics = [
        [/passform|spülkastensystem|spuelkastensystem/i, 'Passform'],
        [/montage|anleitung/i, 'Montage'],
        [/pflege|reinigung/i, 'Pflege'],
        [/ersatzteil/i, 'Ersatzteile'],
        [/produktproblem|reklamation/i, 'Produktproblem'],
        [/bestellung|versand|lieferung|rückgabe|rueckgabe/i, 'Bestellung']
      ];
      const inferredTopic = contextTopics.find(([pattern]) => pattern.test(context));
      const topic = params.get('topic') || (inferredTopic ? inferredTopic[1] : '');
      const normalizedTopic = aliases[(topic || '').toLowerCase()] || topic;
      this.setOption('[name="contact[Anliegen]"]', normalizedTopic);

      const contextModel = context.match(/\b(?:bullseat|bs)[\s-]*(\d+)\b/i);
      const inferredModel = contextModel ? contextModel[1] : /\bpiano\b/i.test(context) ? 'Piano' : '';
      const rawModel = (params.get('model') || inferredModel).trim();
      const id = rawModel.toLowerCase().replace(/^(bullseat|bs)[\s-]*/, '');
      const model = /^\d+$/.test(id) ? `Bullseat ${id}` : id === 'piano' ? 'Piano' : rawModel;
      this.setOption('[name="contact[Modell]"]', model);

      // Carry only the customer's known ceramic details into an empty message.
      // Plain textarea.value assignment never interprets query text as HTML.
      const message = this.querySelector('[name="contact[body]"]');
      if (message && !message.value.trim()) {
        const cleanValue = (key) => (params.get(key) || '')
          .replace(/[\u0000-\u001f\u007f<>]/g, ' ')
          .replace(/\s+/g, ' ').trim().slice(0, 128);
        const details = [
          ['Keramikmarke', cleanValue('ceramic_brand')],
          ['Keramikserie', cleanValue('ceramic_series')],
          ['Form', cleanValue('ceramic_shape')]
        ].filter(([, value]) => value).map(([label, value]) => `${label}: ${value}`);
        if (details.length) message.value = `Ich benötige Hilfe bei der Passform.\n\n${details.join('\n')}\n\nMeine Frage:\n`;
      }
    }

    setOption(selector, value) {
      if (!value) return;
      const select = this.querySelector(selector);
      if (select && [...select.options].some(option => option.value === value)) select.value = value;
    }
  }

  customElements.define('bs-support-contact', BullseatSupportContact);
})();
